import type { AxiosResponse } from 'axios';

import { baseRoutes, baseUrl } from '@/api/config';
import type { ResponseWithPagination } from '@/utils/types';

import axiosInstance from '../../instance';
import ROUTES from '../../routes';
import type {
  AggregatedIncidentsCarResponse,
  AggregatedIncidentsTimeResponse,
  IIncident,
  IncidentsAggregateCarBody,
  IncidentsAggregateTimeBody,
  IncidentsFullBody,
} from './types';

export const getFullIncidents = (
  data: IncidentsFullBody,
): Promise<void | AxiosResponse<ResponseWithPagination<IIncident>>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutes}`,
  url: `${ROUTES.INCIDENTS}/full`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const getAggregatedIncidentsTime = (
  data: IncidentsAggregateTimeBody,
): Promise<void | AxiosResponse<AggregatedIncidentsTimeResponse []>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutes}`,
  url: `${ROUTES.INCIDENTS}/aggregate-time`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const getAggregatedIncidentsCar = (
  data: IncidentsAggregateCarBody,
): Promise<void | AxiosResponse<AggregatedIncidentsCarResponse>> => axiosInstance({
  baseURL: `${baseUrl}${baseRoutes}`,
  url: `${ROUTES.INCIDENTS}/aggregate-car`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

